import { Link } from 'react-router-dom';

const Dashboard = () => {
  const features = [
    {
      title: '測試計劃生成',
      description: '使用 Gemini AI 根據需求生成詳細的測試計劃',
      icon: '📝',
      path: '/test-plan',
      color: 'bg-blue-500',
    },
    {
      title: '虛擬教室創建',
      description: '快速創建 HiLink 虛擬教室進行測試',
      icon: '🏫',
      path: '/virtual-room',
      color: 'bg-green-500',
    },
  ];

  return (
    <div className="px-4 py-6 sm:px-0">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          歡迎使用 HiLink 內部工具
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          這是一個簡化的 MVP 版本，提供測試計劃生成和虛擬教室創建功能
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {features.map((feature) => (
          <Link
            key={feature.path}
            to={feature.path}
            className="block p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            <div className="flex items-center mb-4">
              <div className={`w-12 h-12 ${feature.color} rounded-lg flex items-center justify-center text-white text-2xl mr-4`}>
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900">
                {feature.title}
              </h3>
            </div>
            <p className="text-gray-600">
              {feature.description}
            </p>
          </Link>
        ))}
      </div>

      <div className="mt-12 text-center">
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 max-w-2xl mx-auto">
          <h3 className="text-lg font-medium text-yellow-800 mb-2">
            ⚡ MVP 版本功能
          </h3>
          <ul className="text-sm text-yellow-700 space-y-1">
            <li>• 暫時跳過用戶認證功能</li>
            <li>• 專注於核心 API 整合</li>
            <li>• 簡化的前端介面</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;